import { LifeInsuredPerson } from '@app/domain/model/LifeInsuredPerson';

export const INITIAL_INSURED_PERSON: LifeInsuredPerson = {
    id: '',
    personalCode: '',
    tkc: '',
    name: '',
    email: '',
    phone: '',
    main: true,
    address: null,
    isPolicyHolder: true,
};
